// src/context/CartContext.jsx
import React, { createContext, useContext, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState([]);
  const [cartOpen,  setCartOpen]  = useState(false);

 const addToCart = (product, colorIdx = 0) => {
  setCartItems(prev => {
    const existing = prev.find(i => i.id === product.id && i.personalisedName === product.personalisedName);
    if (existing) {
      return prev.map(i => (i.id === product.id && i.personalisedName === product.personalisedName)
        ? { ...i, qty: (i.qty || 1) + 1 }
        : i);
    }
  return [...prev, {
  id:           product.id,
  name:         product.name,
  subtitle:     product.subtitle,
  price:        product.price,
  comparePrice: product.comparePrice,
  image:        product.image,
  color:        product.swatches?.[colorIdx] || null,
  slug:         product.id,
  basePath:     product.basePath || null,
  qty:          1,
  // ── Personalization fields ──
  personalisedName: product.personalisedName || null,
  paperType:        product.paperType || null,
  coverType:        product.coverType || null,
  // ── Photobook-specific fields — checkout ke waqt customer info attach karne ke liye zaroori ──
  orderRef:     product.orderRef || null,
  pdfUrl:       product.pdfUrl || null,
}];
  });
  setCartOpen(true);
};
  const updateQty = (index, qty) => {
    if (qty < 1) return;
    setCartItems(prev => prev.map((item, i) => i === index ? { ...item, qty } : item));
  };

  // index se remove karo — CartPage isi tarah call kar raha hai (removeFromCart(idx))
  const removeFromCart = (index) => {
    setCartItems(prev => prev.filter((_, i) => i !== index));
  };

  const updateCartItem = (id, updates) => {
  setCartItems(prev => prev.map(item =>
    item.id === id ? { ...item, ...updates } : item
  ));
};

  const clearCart = () => setCartItems([]);

  const totalItems = cartItems.reduce((s, i) => s + (i.qty || 1), 0);

  return (
    <CartContext.Provider value={{
      cartItems,
      cartOpen,
      setCartOpen,
      addToCart,
      updateQty,
      removeFromCart,
      clearCart,
      totalItems,
      updateCartItem,
    }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}